import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getClientManagementList } from "../Actions/ClientManagementAPI";
import { normalizeClientRecord } from "../helpers/clientManagementNormalize";
import ClientContactUsersReadOnly from "./ClientContactUsersReadOnly";
import "./UserManagementMaster.css";

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  CompanyName: "",
  Mail: "",
  Phone: "",
  ClientType: "",
  PageNumber: 1,
  PageSize: 15,
};

class ClientManagementEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      clientUsers: [],
      usersLoading: false,
      clientInfo: {
        clientId: 0,
        companyName: "",
        mail: "",
        address: "",
        telephone: "",
        clientType: "",
        isDeleted: false,
        createdBy: currentUser?.name || "",
        modifiedBy: currentUser?.name || "",
      },
      fieldErrors: {
        companyName: "",
        mail: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    const { match, dispatch, t } = this.props;
    const clientId = match.params.id;
    const isCreateMode = !clientId;

    dispatch({
      type: "SubBannerTitle",
      data: (
        isCreateMode
          ? t("ClientManagementScreenContent.AddClient")
          : t("ClientManagementScreenContent.EditClient")
      ).toUpperCase(),
    });
    dispatch({ type: "ShowSidePan", data: false });

    if (!isCreateMode) {
      this.loadClient(clientId);
    }
  }

  isCreateMode() {
    return !this.props.match.params.id;
  }

  loadClient(clientId) {
    this.setState({ loading: true });
    this.loadClientUsers(clientId);

    axios
      .get(`${API.getClientDetails}?clientId=${clientId}`)
      .then((response) => {
        const data = normalizeClientRecord(response.data || {});
        this.setState({
          clientInfo: {
            clientId: data.clientId || 0,
            companyName: data.companyName,
            mail: data.mail,
            address: data.address,
            telephone: data.telephone,
            clientType: data.clientType,
            isDeleted: false,
            createdBy: data.createdBy || currentUser?.name || "",
            modifiedBy: currentUser?.name || "",
          },
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        toast.error(this.props.t("CommonText.500ErrorMessage"));
      });
  }

  loadClientUsers(clientId) {
    if (!clientId) {
      this.setState({ clientUsers: [], usersLoading: false });
      return;
    }

    this.setState({ usersLoading: true });

    axios
      .get(`${API.getClientUsers}?clientId=${clientId}`)
      .then((response) => {
        this.setState({
          clientUsers: Array.isArray(response.data) ? response.data : [],
          usersLoading: false,
        });
      })
      .catch(() => {
        this.setState({ clientUsers: [], usersLoading: false });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let nextValue = value;

    if (name === "telephone") {
      const input = e.target;
      nextValue = input.validity.valid ? value : this.state.clientInfo.telephone;
    }

    this.setState((prevState) => ({
      clientInfo: {
        ...prevState.clientInfo,
        [name]: nextValue,
      },
      fieldErrors: {
        ...prevState.fieldErrors,
        [name]: "",
      },
    }));
  }

  isValidEmail(email) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test((email || "").trim());
  }

  validateForm(t) {
    const { clientInfo } = this.state;
    const fieldErrors = {
      companyName: "",
      mail: "",
    };

    if (!(clientInfo.companyName || "").trim()) {
      fieldErrors.companyName = t("ErrorMessage.RequiredMsg");
    }

    if (!(clientInfo.mail || "").trim()) {
      fieldErrors.mail = t("MMPLUserManagementContent.Emailismandatory");
    } else if (!this.isValidEmail(clientInfo.mail)) {
      fieldErrors.mail = t("ErrorMessage.InvalidMsg");
    }

    this.setState({ fieldErrors });
    return !fieldErrors.companyName && !fieldErrors.mail;
  }

  handleCancel() {
    const { history } = this.props;
    history.push("/Home/ClientManagement");
    window.scrollTo(0, 0);
  }

  createClient() {
    const { dispatch, t, history } = this.props;
    const { clientInfo } = this.state;

    this.setState({ saving: true });

    axios
      .get(`${API.userExist}?Mail=${encodeURIComponent(clientInfo.mail)}`, {
        headers: { key: currentUser.accessToken },
      })
      .then((existResponse) => {
        if (existResponse.data !== true) {
          this.setState({ saving: false });
          toast.warning(t("ShipManagementContent.UserWaringMsg"));
          return;
        }

        axios
          .post(API.getClientDetails, clientInfo, {
            headers: { key: currentUser.accessToken },
          })
          .then((response) => {
            if (response.data) {
              dispatch(getClientManagementList(defaultSearchData));
              toast.success(t("CommonText.CommonAdd"));
              history.push("/Home/ClientManagement");
              window.scrollTo(0, 0);
            }
            this.setState({ saving: false });
          })
          .catch(() => {
            this.setState({ saving: false });
            toast.error(t("CommonText.500ErrorMessage"));
          });
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  updateClient() {
    const { dispatch, t, history } = this.props;
    const { clientInfo } = this.state;

    this.setState({ saving: true });

    axios
      .put(API.getClientDetails, clientInfo, {
        headers: { key: currentUser.accessToken },
      })
      .then(() => {
        dispatch(getClientManagementList(defaultSearchData));
        toast.success(t("CommonText.CommonUpdate"));
        history.push("/Home/ClientManagement");
        window.scrollTo(0, 0);
        this.setState({ saving: false });
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error(t("CommonText.500ErrorMessage"));
      });
  }

  handleSave() {
    const { t } = this.props;
    if (!this.validateForm(t)) {
      return;
    }

    if (this.isCreateMode()) {
      this.createClient();
    } else {
      this.updateClient();
    }
  }

  renderFormField(label, name, placeholder, iconClass, type = "text", required = false, inputPattern = null) {
    const error = this.state.fieldErrors[name];

    return (
      <div className={`col-lg-3 col-md-6 um-filter-field${error ? " has-error" : ""}`}>
        <label className="form-label">
          {label}
          {required ? <span className="um-required">*</span> : null}
        </label>
        <div className={`um-input-shell${error ? " is-invalid" : ""}`}>
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.clientInfo[name]}
            onChange={this.handleChange}
            pattern={inputPattern || undefined}
            aria-invalid={error ? "true" : "false"}
          />
        </div>
        {error ? (
          <div className="um-field-error" role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{error}</span>
          </div>
        ) : null}
      </div>
    );
  }

  renderClientTypeField(t) {
    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">
          {t("ClientManagementScreenContent.Owner/ManagementCompany")}
        </label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className="fa fa-briefcase" aria-hidden="true"></i>
          </span>
          <div className="um-select-wrap">
            <select
              className="form-control um-select"
              name="clientType"
              value={this.state.clientInfo.clientType}
              onChange={this.handleChange}
            >
              <option value="">{t("ClientManagementScreenContent.SelectType")}</option>
              <option value="Owner">{t("ClientManagementScreenContent.Owner")}</option>
              <option value="Management company">
                {t("ClientManagementScreenContent.ManagementCompany")}
              </option>
            </select>
            <i className="fa fa-chevron-down um-field-dropdown-chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { loading, saving, clientUsers, usersLoading } = this.state;
    const isCreateMode = this.isCreateMode();

    if (loading) {
      return (
        <div className="full-height user-module-master um-edit-page um-client-edit-page">
          <div className="um-empty-state pt-5">Loading...</div>
        </div>
      );
    }

    return (
      <div className="full-height user-module-master um-edit-page um-client-edit-page">
        <div className="pt-3">
          <button
            type="button"
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.handleCancel}
          >
            <span>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-institution um-section-title-icon" aria-hidden="true"></i>
                {t("EquipmentManagementScreenContent.BasicInformation")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="row um-form-grid">
                {this.renderFormField(
                  t("ShipManagementContent.CompanyName"),
                  "companyName",
                  t("ShipManagementContent.CompanyName"),
                  "fa-institution",
                  "text",
                  true
                )}
                {this.renderFormField(
                  t("ServicedByScreenContent.Email"),
                  "mail",
                  t("ServicedByScreenContent.Email"),
                  "fa-envelope-o",
                  "email",
                  true
                )}
                {this.renderFormField(
                  t("ClientManagementScreenContent.Phone"),
                  "telephone",
                  t("ClientManagementScreenContent.Phone"),
                  "fa-phone",
                  "text",
                  false,
                  "[0-9]*"
                )}
                {this.renderFormField(
                  t("ClientManagementScreenContent.Address"),
                  "address",
                  t("ClientManagementScreenContent.Address"),
                  "fa-map-marker"
                )}
                {this.renderClientTypeField(t)}
              </div>
            </div>
          </div>

          {!isCreateMode ? (
            <ClientContactUsersReadOnly users={clientUsers} loading={usersLoading} />
          ) : null}

          <div className={`um-form-actions um-client-edit-form-actions${saving ? " is-saving" : ""}`}>
            <button
              type="button"
              className="btn btn-primary text-uppercase um-btn um-btn-primary"
              onClick={this.handleSave}
              disabled={saving}
            >
              {isCreateMode
                ? t("ShipManagementContent.Add")
                : t("EquipmentServiceTypes.Update")}
            </button>
            <button
              type="button"
              className="btn btn-light text-uppercase um-btn um-btn-secondary"
              onClick={this.handleCancel}
              disabled={saving}
            >
              {t("ComplianceandBudgetScreen.Cancel")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default withTranslation()(
  withRouter(connect(null, mapDispatchToProps)(ClientManagementEdit))
);
